import React from "react";

import "./styles.css";

function SubHeader({ title, renderSide }) {
  return (
    <div className="SubHeader">
      <h1 className="SubHeader__title">{title}</h1>
      {renderSide ? renderSide() : null}
    </div>
  );
}

export default SubHeader;
